import { css } from 'styled-system/css';

export const Styles = {
	float: css({
		pos: 'relative',
	}),
	floatButton: css({
		position: 'relative',
		width: '65px',
		height: '65px',
		filter: 'drop-shadow(0px 8px 12px {colors.blackOpacity.12})',
		pointerEvents: 'auto',
	}),
	closeButton: css({
		position: 'absolute',
		top: '-10px',
		right: '-10px',
		pointerEvents: 'auto',
	}),
	container: css({
		position: 'fixed',
		top: 'calc(var(--header-height) + var(--sports-menu-height) + var(--page-header-height))',
		left: 0,
		right: 0,
		bottom: 'calc(var(--appbar-height) + 42px)',
		zIndex: -1,
		md: {
			top: 'calc(var(--header-height) + var(--page-header-height))',
			bottom: '100px', // 避開 betslip 這是大概值
			left: '240px',
		},
		lgx: {
			right: '391px' // aside(383) + scroll(8)
		},
		xl: {
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
		},
		_galaxy: {
			bottom: 100,
		},
	}),
}